/*

? First, let's import the interface that will describe the shape of our bidding_cycle object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the bidding_cycle object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const client_crm_integration_webhooks: StateInterface["client_crm_integration_webhooks"] = {
	_id: "",
	channel_id: "",
	api_method: "",
	webhook_url: "",
	payload_type: "",
	crm_name: "",
	api_key: "",
	field_name_mapping: {
		channel_id: "",
		lead_id: "",
		name: "",
		phone: "",
		email: "",
		project_name: "",
		status: "",
		notes: "",
		lead_source: "",
		enquired_at: "",
		api_key: "",
	},
	headers: [
		{
			key: "",
			value: "",
		},
	],
	client_id: {
		is_business_profile: false,
		user_id: "",
		business_profile_id: "",
	},
	created_at: new Date(),
	updated_at: new Date(),
	is_deleted: false,
	deleted_at: new Date(),
	is_enabled: false,
	enabled_or_disabled_at: new Date(),
	client_secret_ids: []
};
